import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { API_URL } from '../../../config/constants';
import RawLvTds from '../rawData/components/RawLvTds';
import IndexLvTds from './components/IndexLvTds';
import DataLvTds from './components/DataLvTds';
import ChkBoxDropdown from '../../components/ChkBoxDropdown';
import Select from 'react-select';
import arrowIconImg from '../../../images/filledArrowIcon.png';

function CreateSumDataStruct(props) {

    async function getUsers() {
        await axios.post(`${API_URL}/monitoring-manage/users`).then(response => {
            const { data } = response;
            setUsers([...data]);
        });
    }

    async function getOrganization() {
        const response = await axios.get(`${API_URL}/monitoring-manage/regGetOrg`);
        setOrgArr([...response.data]);
    };
    const [orgArr, setOrgArr] = useState([]);
    const navigate = useNavigate();
    const defaultDataForm = {
        name: '',
        grpNo: 1,
        grpName: [''],
        dataClass: [''],
        indexNo: [1],
        indexName: [['']],
        isCalc: [[false]],
        calcEq: [[null]],
        indexType: [['']],
        indexDim: [[null]],
        valView: [[true]],
        variView: [[true]],
        applyToOkNg: [[true]],
        okNgView: [true],
        indexComment: [[null]],
        organization: -1,
        owner: [],
        comment: null,
    };
    const [formData, setFormData] = useState(defaultDataForm);
    const [changed, setChanged] = useState(false);
    const [users, setUsers] = useState([]);

    const onChangeOrg = sel => {
        setFormData({ ...formData, organization: sel.value });
    }

    const chgMonit = () => {
        const changed = JSON.stringify(formData) !== JSON.stringify(defaultDataForm);
        setChanged(changed);
    };

    const wholeColAmount = formData.indexNo.reduce((prev, cur) => prev + cur, 0);
    const onChange = (e) => {
        e.preventDefault();
        const { name, value, type } = e.target;
        let convVal = type === 'number' ? parseInt(value) : value;
        if (name === 'grpNo') {
            // 현재 데이터 그룹 수
            const curDataAmount = formData.grpNo;
            const { grpName, dataClass, indexNo, indexName, isCalc, indexType, calcEq, indexDim, indexComment, valView, variView, applyToOkNg, okNgView } = formData;
            const increaseFx = (curArr, incr, defaultValue) => ([...curArr, ...Array(incr).keys().map((_) => (defaultValue))]);
            const decreaseFx = (curArr, newAmount) => (curArr.slice(0, newAmount));
            if (convVal > curDataAmount) {
                // 데이터 그룹 수를 증가시킨 경우
                const increase = convVal - curDataAmount;
                const newDataName = increaseFx(grpName, increase, '');
                const newDataClass = increaseFx(dataClass, increase, '');
                const newIndexNo = increaseFx(indexNo, increase, 1);
                const newIndexName = increaseFx(indexName, increase, ['']);
                const newIsCalc = increaseFx(isCalc, increase, [false]);
                const newValView = increaseFx(valView, increase, [true]);
                const newVariView = increaseFx(variView, increase, [true]);
                const newApplyToOkNg = increaseFx(applyToOkNg, increase, [true]);
                const newOkNgView = increaseFx(okNgView, increase, true);
                const newIndexType = increaseFx(indexType, increase, ['']);
                const newIndexDim = increaseFx(indexDim, increase, [null]);
                const newCalcEq = increaseFx(calcEq, increase, [null]);
                const newIndexComment = increaseFx(indexComment, increase, [null]);

                setFormData(prev => ({
                    ...prev,
                    grpNo: convVal,
                    grpName: newDataName,
                    dataClass: newDataClass,
                    indexNo: newIndexNo,
                    indexName: newIndexName,
                    isCalc: newIsCalc,
                    valView: newValView,
                    variView: newVariView,
                    applyToOkNg: newApplyToOkNg,
                    okNgView: newOkNgView,
                    indexType: newIndexType,
                    calcEq: newCalcEq,
                    indexDim: newIndexDim,
                    indexComment: newIndexComment,
                }));

            } else {
                // 데이터 그룹 수를 감소시킨 경우
                const newDataName = decreaseFx(grpName, convVal);
                const newDataClass = decreaseFx(dataClass, convVal);
                const newIndexNo = decreaseFx(indexNo, convVal);
                const newIndexName = decreaseFx(indexName, convVal);
                const newIsCalc = decreaseFx(isCalc, convVal);
                const newValView = decreaseFx(valView, convVal);
                const newVariView = decreaseFx(variView, convVal);
                const newApplyToOkNg = decreaseFx(applyToOkNg, convVal);
                const newOkNgView = decreaseFx(okNgView, convVal);
                const newIndexType = decreaseFx(indexType, convVal);
                const newCalcEq = decreaseFx(calcEq, convVal);
                const newIndexDim = decreaseFx(indexDim, convVal);
                const newIndexComment = decreaseFx(indexComment, convVal);

                setFormData(prev => ({
                    ...prev,
                    grpNo: convVal,
                    grpName: newDataName,
                    dataClass: newDataClass,
                    indexNo: newIndexNo,
                    indexName: newIndexName,
                    isCalc: newIsCalc,
                    valView: newValView,
                    variView: newVariView,
                    applyToOkNg: newApplyToOkNg,
                    okNgView: newOkNgView,
                    indexType: newIndexType,
                    calcEq: newCalcEq,
                    indexDim: newIndexDim,
                    indexComment: newIndexComment,
                }))
            }
        } else {
            setFormData(prev => ({ ...prev, [name]: convVal }));
        }
    };

    const onChangeDataLevel = (e, tgtName, index) => {
        // e.preventDefault();
        const { value, type } = e.target;
        const convVal = type === 'number' ? parseInt(value) : tgtName === 'okNgView' ? JSON.parse(value) : value;
        const newArray = [...formData[tgtName]];
        newArray[index] = convVal;
        if (tgtName === 'indexNo') {
            // 현재 데이터 그룹 수
            const curIndexNo = formData.indexNo[index];
            const { indexName, isCalc, calcEq, indexType, indexDim, indexComment, valView, variView, applyToOkNg } = formData;
            const increaseFx = (curArr, incr, defaultValue) => {
                let copiedArr = [...curArr];
                copiedArr[index] = [...copiedArr[index], ...Array(incr).keys().map((_) => (defaultValue))];
                return copiedArr;
            };
            const decreaseFx = (curArr, newAmount) => {
                const copiedArr = [...curArr];
                copiedArr[index] = copiedArr[index].slice(0, newAmount);
                return copiedArr;
            };

            if (convVal > curIndexNo) {
                // 데이터 그룹 수를 증가시킨 경우
                const increase = convVal - curIndexNo;
                const newIndexName = increaseFx(indexName, increase, '');
                const newIsCalc = increaseFx(isCalc, increase, false);
                const newValView = increaseFx(valView, increase, true);
                const newVariView = increaseFx(variView, increase, true);
                const newApplyToOkNg = increaseFx(applyToOkNg, increase, true);
                const newIndexType = increaseFx(indexType, increase, '');
                const newCalcEq = increaseFx(calcEq, increase, null);
                const newIndexDim = increaseFx(indexDim, increase, null);
                const newIndexComment = increaseFx(indexComment, increase, null);
                setFormData(prev => ({
                    ...prev,
                    [tgtName]: newArray,
                    indexName: newIndexName,
                    isCalc: newIsCalc,
                    valView: newValView,
                    variView: newVariView,
                    applyToOkNg: newApplyToOkNg,
                    indexType: newIndexType,
                    calcEq: newCalcEq,
                    indexDim: newIndexDim,
                    indexComment: newIndexComment,
                }));

            } else {
                // 데이터 그룹 수를 감소시킨 경우
                const newIndexName = decreaseFx(indexName, convVal);
                const newIsCalc = decreaseFx(isCalc, convVal);
                const newValView = decreaseFx(valView, convVal);
                const newVariView = decreaseFx(variView, convVal);
                const newApplyToOkNg = decreaseFx(applyToOkNg, convVal);
                const newIndexType = decreaseFx(indexType, convVal);
                const newCalcEq = decreaseFx(calcEq, convVal);
                const newIndexDim = decreaseFx(indexDim, convVal);
                const newIndexComment = decreaseFx(indexComment, convVal);

                setFormData(prev => ({
                    ...prev,
                    [tgtName]: newArray,
                    indexName: newIndexName,
                    isCalc: newIsCalc,
                    valView: newValView,
                    variView: newVariView,
                    applyToOkNg: newApplyToOkNg,
                    indexType: newIndexType,
                    calcEq: newCalcEq,
                    indexDim: newIndexDim,
                    indexComment: newIndexComment,
                }))
            }
        } else {
            setFormData(prev => ({ ...prev, [tgtName]: newArray }));
        }
    };

    const onChangeIndexLevel = (e, tgtName, dataLvIdx, index) => {
        // e.preventDefault();
        const { value, type } = e.target;
        const convVal = type === 'number' ? parseFloat(value) : tgtName === 'indexType' ? value.toUpperCase() : tgtName === 'isCalc' || tgtName === 'valView' || tgtName === 'variView' || tgtName === 'applyToOkNg' ? JSON.parse(value) : value;
        const newOuterArr = [...formData[tgtName]];
        newOuterArr[dataLvIdx][index] = convVal;
        setFormData(prev => ({ ...prev, [tgtName]: newOuterArr }));
    };

    const onChangeUserOwner = (value) => {
        setFormData(prev => ({ ...prev, owner: value }));
    };

    const onSubmit = async e => {
        e.preventDefault();
        await axios.post(`${API_URL}/monitoring-manage/createSumDataStruct`, { newData: formData }).then(res => {
            const { success } = res.data;
            if (success) {
                navigate('/home/dataStructure/sumData')
            }
        })

    };

    const onCancel = e => {
        navigate('/home/dataStructure/sumData')
    };

    useEffect(() => {
        getUsers();
        getOrganization();
    }, []);

    useEffect(() => {
        chgMonit();
    }, [formData]);

    const orgOptArr = orgArr.map(el => ({ label: el.name, value: el.id }));

    return (
        <div className='editSumDataStruct'>
            <p className='path'>데이터 구조 관리<span className='below'>{'>'}</span>요약 데이터 구조<span className='below'>{'>'}</span>요약 데이터 구조 추가</p>
            <h2 className='pageTitle'>요약 데이터 구조 추가</h2>
            <table>
                <tbody>
                    <tr>
                        <th>공정요약 이름</th>
                        <td colSpan={wholeColAmount}>
                            <input name='name' value={formData.name ?? ''} onChange={onChange} />
                        </td>
                    </tr>
                    <tr>
                        <th>데이터 그룹 수</th>
                        <td colSpan={wholeColAmount}>
                            <input type='number' name='grpNo' value={formData.grpNo ?? 1} onChange={onChange} min={1} />
                        </td>
                    </tr>
                    <tr>
                        <th>데이터 그룹 이름</th>
                        <DataLvTds
                            arr={formData.grpName}
                            indexNo={formData.indexNo}
                            title={'grpName'}
                            onChange={onChangeDataLevel}
                        />
                    </tr>
                    <tr>
                        <th>분류</th>
                        <DataLvTds
                            arr={formData.dataClass}
                            indexNo={formData.indexNo}
                            title={'dataClass'}
                            onChange={onChangeDataLevel}
                        />
                    </tr>
                    <tr>
                        <th>세부 데이터 수</th>
                        <DataLvTds
                            arr={formData.indexNo}
                            indexNo={formData.indexNo}
                            title={'indexNo'}
                            inputType={'number'}
                            onChange={onChangeDataLevel}
                        />
                    </tr>
                    <tr>
                        <th>세부 데이터 이름</th>
                        <IndexLvTds
                            outArr={formData.indexName}
                            title={'indexName'}
                            onChange={onChangeIndexLevel}
                        />
                    </tr>
                    <tr>
                        <th>데이터 유형</th>
                        <IndexLvTds
                            outArr={formData.indexType}
                            title={'indexType'}
                            onChange={onChangeIndexLevel}
                            isType={true}
                        />
                    </tr>
                    <tr>
                        <th>단위</th>
                        <IndexLvTds
                            outArr={formData.indexDim}
                            title={'indexDim'}
                            onChange={onChangeIndexLevel}
                        />
                    </tr>
                    <tr>
                        <th>세부 데이터 코멘트</th>
                        <IndexLvTds
                            outArr={formData.indexComment}
                            title={'indexComment'}
                            onChange={onChangeIndexLevel}
                        />
                    </tr>
                    <tr>
                        <th>계산 데이터 여부</th>
                        <IndexLvTds
                            outArr={formData.isCalc}
                            title={"isCalc"}
                            onChange={onChangeIndexLevel}
                            inputType={"checkbox"}
                        />
                    </tr>
                    <tr>
                        <th>계산식</th>
                        <IndexLvTds
                            outArr={formData.calcEq}
                            title={"calcEq"}
                            onChange={onChangeIndexLevel}
                            uneditableCond={(outerIdx, innerIdx) => !!!formData.isCalc[outerIdx][innerIdx]}
                        />
                    </tr>
                    <tr>
                        <th>값 표시</th>
                        <IndexLvTds
                            outArr={formData.valView}
                            title={"valView"}
                            onChange={onChangeIndexLevel}
                            inputType={"checkbox"}
                        />
                    </tr>
                    <tr>
                        <th>편차 표시</th>
                        <IndexLvTds
                            outArr={formData.variView}
                            title={"variView"}
                            onChange={onChangeIndexLevel}
                            inputType={"checkbox"}
                        />
                    </tr>
                    <tr>
                        <th>판정 적용</th>
                        <IndexLvTds
                            outArr={formData.applyToOkNg}
                            title={"applyToOkNg"}
                            onChange={onChangeIndexLevel}
                            inputType={"checkbox"}
                        />
                    </tr>
                    <tr>
                        <th>판정 표시</th>
                        <DataLvTds
                            arr={formData.okNgView}
                            indexNo={formData.indexNo}
                            title={'okNgView'}
                            inputType={'checkbox'}
                            onChange={onChangeDataLevel}
                        />
                    </tr>
                    <tr>
                        <th>소속</th>
                        <td colSpan={wholeColAmount}>
                            <Select
                                options={orgOptArr}
                                onChange={sel => onChangeOrg(sel)}
                                value={orgOptArr.find(el => el.value === formData.organization)}
                                isSearchable={false}
                                maxMenuHeight={'225px'}
                                placeholder={'소속'}
                                classNames={{
                                    control: (state) => 'control',
                                    container: (state) => 'selectBox',
                                    dropdownIndicator: (state) => 'arrow',
                                    menu: (state) => 'options',
                                    option: (state) => state.isSelected ? 'option selected' : state.isFocused ? 'option focused' : 'option',
                                    singleValue: (state) => 'singleVal',
                                    valueContainer: (state) => 'valueContainer',
                                    placeholder: (state) => 'placeholder'
                                }}
                                components={{
                                    DropdownIndicator: (state) => <span className={state.isFocused ? 'arrowIcon focused' : 'arrowIcon'} ><img src={arrowIconImg} alt={'드롭다운'} /></span>,
                                    IndicatorSeparator: (state) => null,
                                }}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>담당자</th>
                        <td colSpan={wholeColAmount}>
                            <ChkBoxDropdown
                                value={formData.owner}
                                options={users.map(el => ({ id: el.id, name: el.userName }))}
                                onChange={(e, value) => {
                                    e.preventDefault();
                                    onChangeUserOwner(value);
                                }}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>코멘트</th>
                        <td colSpan={wholeColAmount}>
                            <input name='comment' value={formData.comment ?? ''} onChange={onChange} />
                        </td>
                    </tr>
                </tbody>

            </table>

            <div className='editBtnsArea'>
                <button className='submitBtn' onClick={onSubmit}>확인</button>
                <button className='cancelBtn' onClick={onCancel}>취소</button>
            </div>

        </div>
    );
}

export default CreateSumDataStruct;